module.exports = __webpack_public_path__ + "img/logo-dashboard-header.51ba325a.png";